import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Tab } from "@mui/material";
import { useState } from "react";
import { StyledCustomTabs } from '../../styled/CustomTabs';
import { StyledContainer } from '../../styled/Layout';
import DataLabel from "../labels/DataLabel";


const CustomTab = ({
  optionsTabs,
  configurationTabs,
  selectedAccident,
  backArrow,
  withLabelData,
}) => {
  const [value, setValue] = useState("1");

  const handlerChangeTabs = (dataTab, valueTab) => {
    setValue(valueTab);
  };

  return (
    <StyledContainer.Paper>
      <TabContext value={value}>
        {backArrow && backArrow}
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList
            onChange={handlerChangeTabs}
            textColor={configurationTabs.textColor}
            indicatorColor={configurationTabs.indicatorColor}
            centered={configurationTabs.centered}
            variant={configurationTabs.variant}
            orientation={configurationTabs.orientation || "horizontal"}
          >
            {optionsTabs &&
              optionsTabs.map(({ label, value, wrapped, disabled }) => (
                <Tab
                  key={value}
                  label={label}
                  value={value}
                  wrapped={wrapped}
                  disabled={disabled}
                />
              ))}
          </TabList>
        </Box>
        {withLabelData && (
          <StyledCustomTabs.LabelContainer>
            <DataLabel
              firstText={selectedAccident.siniestroART}
              secondText={selectedAccident.tipoSiniestro}
              thirdText={selectedAccident.apellidoNombre}
            />
          </StyledCustomTabs.LabelContainer>
        )}
        {optionsTabs &&
          optionsTabs.map(({ component, value }) => (
            <TabPanel value={value} key={value}>
              {component(selectedAccident)}
            </TabPanel>
          ))}
      </TabContext>
    </StyledContainer.Paper>
  );
};

export default CustomTab;
